/**
 * Shared timeout utility for AbortController-based fetch timeouts.
 */

/**
 * Creates an AbortController and schedules an abort after `ms` milliseconds.
 * Usage:
 *   const { controller, timer } = withTimeout(8000);
 *   try {
 *     await fetchWithAuth(url, { signal: controller.signal });
 *   } finally {
 *     clearTimeout(timer);
 *   }
 */
export const withTimeout = (ms = 5000): { controller: AbortController; timer: ReturnType<typeof setTimeout> } => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), ms);
    return { controller, timer };
};
